export default function qbGenerateRequest(
  queryComponents,
  queryData,
  recipeInfo = null
) {
  // if (!queryComponents) return true;
  const req = {
    query_options: 1,
    visualizer: queryData.visualizer,
  };

  if (recipeInfo?.custom_report_comp === "response_filter") {
    const questionsToSave = queryData.selected_questions.filter(
      (f) => f.selected_items.length > 0
    );
    const uniqueQuestionCount = questionsToSave.length;
    const formattedQuestions = queryData.selected_questions.map((m) => ({
      question_id: m.id,
      select_item_ids: m.selected_items.map((m) => m.id),
    }));
    req.select_item_ids = formattedQuestions.flatMap((m) => m.select_item_ids);
    req.or_query = uniqueQuestionCount === 1;
    req.saved_selected_questions = questionsToSave;
  } else {
    queryComponents.forEach((qc) => {
      if (Array.isArray(queryData[qc.clientName])) {
        req[qc.clientName] = queryData[qc.clientName].map((m) => {
          if (typeof m === "object") {
            return m.value;
          } else {
            return m;
          }
        });
        if (queryData[`${qc.clientName}_preserved_options`]) {
          req[`${qc.clientName}_preserved_options`] =
            queryData[`${qc.clientName}_preserved_options`];
        }
      } else {
        req[qc.clientName] = queryData[qc.clientName];
      }
    });
  }

  return req;
}
